import i18n, { TFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

/** The default and the fallback language */
export const I18N_DEFAULT_LANGUAGE = 'default';

/** Language used to test if translations are setup correctly */
export const I18N_DEFAULT_NAMESPACE = 'translation';

interface Settings {
  useBackend?: boolean;
  useLanguageDetector?: boolean;
  preferredLanguage?: string;
}

export const i18nNextInit = (settings: Settings = {}): Promise<TFunction> => {
  const instance = i18n;

  if (settings.useBackend === true) {
    i18n.use(Backend);
  }

  if (settings.useLanguageDetector === true) {
    i18n.use(LanguageDetector);
  }

  return (
    instance
      .use(initReactI18next)
      // init i18next
      // for all options read: https://www.i18next.com/overview/configuration-options
      .init({
        lng: settings.preferredLanguage,
        fallbackLng: [I18N_DEFAULT_LANGUAGE],
        react: {
          useSuspense: false,
        },
        interpolation: {
          // not needed for react as it escapes by default
          escapeValue: false,
        },
        detection: {
          order: ['cookie'],
          lookupCookie: 'i18next',
          cookieMinutes: 525600,
          caches: ['cookie'],
        },
      })
  );
};
